/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conflict_Reason_ManualInputs */

const cs_ebr_conflict_reason_manual = /** @type {(inputs: Ebr_Conflict_Reason_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruční úprava v CRM`)
};

const en_ebr_conflict_reason_manual = /** @type {(inputs: Ebr_Conflict_Reason_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual edit in CRM`)
};

/**
* | output |
* | --- |
* | "Manual edit in CRM" |
*
* @param {Ebr_Conflict_Reason_ManualInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conflict_reason_manual = /** @type {((inputs?: Ebr_Conflict_Reason_ManualInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conflict_Reason_ManualInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conflict_reason_manual(inputs)
	return cs_ebr_conflict_reason_manual(inputs)
});